/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import WarehouseSyncModel from 'cio/models/warehouse-sync';
import FormValidations from 'cio/utils/form-validations';
import { FlyKeyboardEvent } from '@customerio/fly-components/types/fly-components/events';
import { AzureBlobFields, DefaultIntegrationFieldValues } from 'cio/utils/integrations/fields';

interface WarehouseSyncConfigureAzureBlobArgs {
  model: WarehouseSyncModel;
  validations: FormValidations;
}

export default class WarehouseSyncConfigureAzureBlob extends Component<WarehouseSyncConfigureAzureBlobArgs> {
  readonly defaultBucketPath = DefaultIntegrationFieldValues.bucketPath;

  get azureBlobPath(): string {
    let { azureConfig } = this.args.model;

    return azureConfig.bucketPath ?? this.defaultBucketPath;
  }

  @action
  onUpdateInput(key: string, value: string): void {
    this.args.model.azureConfig = { ...this.args.model.azureConfig, [key]: value };
    this.args.validations.validateAttribute(key);
  }

  @action
  updatecontainerSasUrl(e: FlyKeyboardEvent<HTMLInputElement>) {
    this.args.model.azureConfig = { ...this.args.model.azureConfig, [AzureBlobFields.containerSasUrl]: e.target.value };
    this.args.validations.validateAttribute(AzureBlobFields.containerSasUrl);
  }
}
